// src/services/storageService.js
import { getDownloadURL, ref, listAll } from 'firebase/storage';
import { storage } from '../firebase/config';
/**
 * Fetch all images from a specific Firebase Storage path
 * @param {string} path - The path in Firebase Storage
 * @returns {Promise<Array>} - Array of image URLs
 */
export const fetchImagesFromStorage = async (path) => {
    try {
        const storageRef = ref(storage, path);
        const result = await listAll(storageRef);

        // Get download URLs for all items
        const downloadURLs = await Promise.all(
            result.items.map(async (itemRef) => {
                const url = await getDownloadURL(itemRef);
                return {
                    url,
                    name: itemRef.name,
                    fullPath: itemRef.fullPath,
                };
            })
        );

        return downloadURLs;
    } catch (error) {
        console.error('Error fetching images from storage:', error);
        throw error;
    }
};

/**
 * Get a single image URL from Firebase Storage
 * @param {string} path - The full path to the image
 * @returns {Promise<string>} - The download URL
 */
export const getImageURL = async (path) => {
    try {
        const storageRef = ref(storage, path);
        return await getDownloadURL(storageRef);
    } catch (error) {
        console.error('Error getting image URL:', error);
        throw error;
    }
};